import { ReactNode } from 'react';
import { AppHeader } from '../AppHeader';
import { BottomTabBar } from '../BottomTabBar';

interface AppShellProps {
  children: ReactNode;
}

/**
 * AppShell — the authenticated app layout wrapper.
 *
 * Renders both navigation components (each self-hides at the appropriate
 * breakpoint) and offsets <main> so content is never obscured by either nav.
 *
 * Offset strategy (defined in base.css + utilities.css):
 *   - Mobile  (< 800px): padding-bottom = --bottom-tab-bar-height
 *   - Desktop (≥ 800px): padding-top    = --app-header-height
 *
 * Screen components must not add their own offsets to compensate for nav.
 *
 * The <main> element uses `grid-primer` so child pages can use col-span-*
 * classes directly without needing their own grid wrapper.
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-page" data-testid="app-shell">
      <AppHeader />
      <BottomTabBar />
      <main className="grid-primer px-5 app-shell-main">{children}</main>
    </div>
  );
}
